import React, { useState, useEffect } from 'react';
import { popupManager } from '../common/PopupManager';
import { useParams } from 'react-router-dom';

import Borrow from '../lending/Borrow';
//import Lend from '../lending/Lend';
import Mypositions from '../lending/Mypositions';
import { getBalanceAndSymbol } from '../../functions/dexfunctions';
import { getBorrowers, getLenderInfo, getLenders, withdrawETH } from '../../functions/lendingfunctions';
import { getPairAddressForBondedTokenForGraph } from '../../functions/factoryFunctions';
import Stats from '../lending/Stats';
import RewardsPopup from '../lending/RewardsPopup';

export default function Lending({ signer }) {
  const ethAddress = "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2";
  const [activeTab, setActiveTab] = useState(1);
  const {chain } = useParams();
  const [ethBalance, setethBalance] = useState(0)
  const highlightPosition = `${(activeTab - 1) * 100}%`;
  const [lendETHPositions, setlendETHPositions] = useState(null);
  const [lentTaken, setlentTaken] = useState(null);
  const [borrowedETHPositions, setborrowedETHPositions] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [ShowRewards, setShowRewards] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [positionsCount, setpositionsCount] = useState(0)
  const filters = ['Filter 1', 'Filter 2', 'Filter 3', 'Filter 4'];
  const handleToggleFilter = (filter) => {
    setSelectedFilters((prev) =>
      prev.includes(filter)
        ? prev.filter((f) => f !== filter)
        : [...prev, filter]
    );
  };
  function chainParamToChainId(chainParam) {
    switch (chainParam) {
      case "ethereum":
        return 1;
      // add more if needed
      default:
        return null; // or 1 as a default
    }
  }
  useEffect(() => {
    if (!signer) return;

    const requiredChainId = chainParamToChainId(chain);

    // If we don't have a mapping, you might handle that differently
    if (!requiredChainId) return;

    (async () => {
      try {
        // Ethers.js v6 returns an object with .chainId
        const network = await signer.provider.getNetwork();
        const currentChainId = Number(network.chainId);

        if (currentChainId !== requiredChainId) {
          popupManager.addPopup({
            id: Date.now(),
            type: "error",
            message: "Please connect your wallet to the selected network!",
            duration: 6000,
          });
        }
      } catch (err) {
        console.error("Error checking network:", err);
      }
    })();
  }, [signer, chain]);

 useEffect(() => {
    let intervalId; // Declare it in outer scope so we can clear it

    if (signer) {
      // Immediately call the functions when `signer` is truthy
      fetchbal();
      fetchPositions();

      // Set up the interval to call the functions every 15s (15000 ms)
      intervalId = setInterval(() => {
        fetchbal();
        fetchPositions();
      }, 15000);
    }

    // Cleanup function to clear the interval on unmount or re-render
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [signer]);
  const fetchbal = async () => {
    const ethbal = await getBalanceAndSymbol(ethAddress,ethAddress,signer)
    setethBalance(ethbal)

  }
  const fetchPositions = async () => {
    let positions = 0
    let lentETH = await getLenderInfo(await signer.getAddress())
    //console.log(lentETH)
    if(lentETH && lentETH.totalLent > lentETH.ETHAvailable){
      lentETH.status = true
    }
    let lentTakenResult = await getBorrowers(await signer.getAddress())
    //console.log(lentTakenResult.length)
    if(lentTakenResult && (lentTakenResult.length > 0)){
      positions += lentTakenResult.length
    }
    setlentTaken(lentTakenResult)
    setlendETHPositions(lentETH)

    const borrowedETH = await getLenders(await signer.getAddress())
    //console.log(borrowedETH)
    if(borrowedETH && borrowedETH.length > 0 ){
      positions += borrowedETH.length
      setborrowedETHPositions(borrowedETH)
    }
    setpositionsCount(positions)

  }

  const validateChainId = async (signerProvider) => {
    const network = await signerProvider.provider.getNetwork();
      const chainId = Number(network.chainId);
      if (chainId !== 1) {
        popupManager.addPopup({
          id: Date.now(),
          type: "error",
          message: "Please connect your wallet to the ETH network",
          duration: 6000,
        });
        throw Error("Error")
      } 
  }
  async function handleShowRewards(){
    setShowRewards(true);
  }
  async function handleHideRewards(){
    setShowRewards(false)
  }
  async function handleWithdrawETH(){
        let id = Date.now();
  
        try{
          const validateChain = await validateChainId(signer)
          popupManager.addPopup({
            id: id,
            type: "message",
            message: "Withdrawing Lended Ethereum",
          });
          const usdcAddress = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48'; // Example USDC address
          const usdtAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7'; // Example USDT address
          const stableCoinAddress = Math.random() < 0.5 ? usdcAddress : usdtAddress;
          const pairAddress = await getPairAddressForBondedTokenForGraph(
            stableCoinAddress,
            "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
            'ethereum'
          );
          const response = await withdrawETH(pairAddress,signer)
          popupManager.removePopup(id);
          let successful_id = Date.now();
          popupManager.addPopup({
            id: successful_id,
            type: "success",
            message:
              "Transaction sent!",
          });
          }
        catch(e){
          popupManager.removePopup(id);
          popupManager.addPopup({
            id: Date.now(),
            type: "error",
            message: e.toString(),
            duration: 6000,
          });
          console.log(e)
        }
      }
  return (
    <div className=' mt-36 mx-auto max-w-[1300px] px-3 lg:px-12 pb-24  '>
    {/*<div className=" justify-center text-3xl font-[600] text-white ">
      Borrow / Lend
    </div>
    <div className=" justify-center font-[500] text-[15px] mt-1 text-white/60 ">
      Supply ETH or Tokens and receive rewards for liquidity matching
    </div>*/}

      <div className=' '>
      <Stats />


        <div className='flex text-[13px] text-white font-[500] mt-8'>Balance</div>
        <div className="flex items-center">
          {/* ETH Icon */}
          <p className="text-3xl font-[800] kanit-light">
            <img className="h-9 w-9 mt-1" alt="eth" src="/eth.svg" />
          </p>
          
          {/* Integer Part */}
          <p className="text-[35px] font-[700] ml-3">
            {!isNaN(ethBalance)
              ? Math.floor(ethBalance)
              : '-'}
          </p>
                    
          {/* Decimal Part */}
          <p className="text-[35px] font-[700] text-white/50">
            {!isNaN(ethBalance) && (ethBalance - Math.floor(ethBalance)).toFixed(7).slice(1)}
          </p>
        </div>
      </div>
      {/* 3 Buttons */}
      <div className="flex  items-center justify-center sm:justify-between  py-6  mt-6">
        {/* Button container */}
        <div className={`relative flex justify-between ${signer ? " w-[350px]":" w-[234px]"}  rounded-full  text-sm`}>
            {/* Highlight background that slides behind the active button */}
            <span
              className={`absolute inset-0  ${signer ? "w-1/3 ":"w-1/2"} bg-yellow-400/10 border border-yellow-400/40 rounded-sm transition-transform duration-200`}
              style={{ transform: `translateX(${highlightPosition})` }}
            />

            {/* Buttons */}
            <button
              onClick={() => setActiveTab(1)}
              className={`relative z-10 ${signer ? "w-1/3 ":"w-1/2"} py-[6px] rounded-sm  
                transition-colors duration-100
                ${
                  activeTab === 1
                    ? 'text-white '
                    : 'text-gray-500 hover:text-gray-200 '
                }
              `}
            >
              Pools
            </button>
            <button
              onClick={() => setActiveTab(2)}
              className={`relative z-10 ${signer ? "w-1/3 ":"w-1/2"} py-[6px] rounded-sm 
                transition-colors duration-100
                ${
                  activeTab === 2
                    ? 'text-white border-yellow-400/40'
                    : 'text-gray-500 hover:text-gray-200 border-transparent'
                }
              `}
            >
              Positions
              <span className='rounded-full text-white bg-[#46411c] absolute right-[-9px] top-[-12px] py-[px] text-[9px] px-[7px]'>{positionsCount > 0 && positionsCount}</span>
            </button>
            {signer && <button
              onClick={() => handleShowRewards()}
              className={`relative z-10 w-1/3 py-[6px] rounded-sm 
                transition-colors duration-100
                ${
                  activeTab === 3
                    ? 'text-white border-yellow-400/40'
                    : 'text-gray-500 hover:text-gray-200 border-transparent'
                }
              `}
            >
              Rewards
            </button>}
            {/*<button
              onClick={() => setActiveTab(2)}
              className={`relative z-10 w-1/3 py-[6px] rounded-sm  
                transition-colors duration-100
                ${
                  activeTab === 2
                    ? 'text-white border-yellow-400/40'
                    : 'text-gray-500 hover:text-gray-200 border-transparent'
                }
              `}
            >
              Borrow
            </button>*/}
            
        </div>
        


      </div>
      {ShowRewards === true &&  <RewardsPopup signer={signer} validateChainId={validateChainId} handleHideRewards={handleHideRewards} /> }
  
      {activeTab === 1 && <Borrow signer={signer} validateChainId={validateChainId} handleWithdrawETH={handleWithdrawETH} />}
      {/*{activeTab === 2 && <Lend  signer={signer} validateChainId={validateChainId}/>}*/}
      {activeTab === 2 && <Mypositions signer={signer} validateChainId={validateChainId} lendETHPositions={lendETHPositions} handleWithdrawETH={handleWithdrawETH} borrowedETHPositions={borrowedETHPositions}  lentTaken={lentTaken} />}
    
    </div>
  );
}
